<template>
    <div class="flex flex-col w-full">
        <loader v-if="isloading" size="xxs" :loader-image="false" />
        <template v-else-if="hasModuleAccess">
            <div v-if="payScaleTabs.length > 0" class="w-full flex flex-col mt-2 py-5">
                <div class="mb-4 mt-1">
                    <PaySettingsTabs
                        :tabs="tabs"
                        :active-tab="payScaleCurrentTabId"
                        :is-general-setting="false"
                        @tab-change="handleCurrentTab"
                        @edit-tab="onSalaryScaleTabAction('edit')"
                        @add-new-tab="onSalaryScaleTabAction('add')"
                        @next-tab="handleNextTab"
                        @previous-tab="handlePreviousTab"
                    />
                </div>
                <div class="text-jet font-normal leading-5 text-base flex flex-col gap-2 bg-color px-3 py-3 mt-10 rounded-md">
                    <p>
                        Pay Scale entries define the exact salary assigned to each Grade Level and Step  or  Post  in your organisation. 
                        Every employee's salary is resolved at payroll run time by matching their classification to the corresponding entry here. 
                        All entries belong to a Salary Scale, which is the named structure that groups them.
                    </p>
                </div>
                <div class="mx-3 mt-6">
                    <Card class="p-5">
                        <div class="flex gap-2 mb-6" style="justify-content: flex-end">
                            <Button :disabled="!payScaleGroupType"
                                @click="onPayScaleActions('importPayScale')"
                                :class="payScaleGroupType ? 'cursor-pointer opacity-100' : 'cursor-default opacity-50'"
                                class="flex items-center justify-center text-dynamicBackBtn rounded-lg w-28 h-10 bg-white border border-dynamicBackBtn"
                            >
                                Import
                            </Button>
                            <Button :disabled="!payScaleGroupType"
                                @click="onPayScaleActions('addNewPayScale')"
                                :class="payScaleGroupType ? 'cursor-pointer opacity-100' : 'cursor-default opacity-50'"
                                class="flex items-center justify-center text-white bg-dynamicBackBtn rounded-lg w-28 h-10"
                            >
                                Add New
                            </Button>
                        </div>
                    </Card>
                </div>
                <div class="w-full"
                    v-for="(payScaleTab, index) in payScaleTabs"
                    :key="index"
                >
                    <div v-if="payScaleCurrentTabId === payScaleTab.id">
                        <loader v-if="isloading" size="xxs" :loader-image="false" />
                        <div v-else>
                            <card>
                                <template v-slot:footer>
                                    <CardFooter
                                        reloadcard
                                        @reload="reload"
                                    >
                                    </CardFooter>
                                </template>
                            </card>
    
                            <div class="mt-10">
                                <div>
                                    <div class="text-base text-darkPurple font-semibold">
                                        What do you use in defining your scale
                                    </div>
                                    <radio-button
                                        :options="updatePayScaleGroupType"
                                        col-span="col-span-3"
                                        class="m-4 text-darkPurple"
                                        row-gap="gap-y-1"
                                        @change="onDefineScaleCategory()"
                                        v-model="payScaleGroupType"
                                    />
                                </div>
                            </div>
    
                            <card class="w-full mt-6">
                                <div class="flex flex-col">
                                    <div
                                        class="w-full flex flex-col"
                                        v-if="payScalesData.length !== 0 || loading"
                                    >
                                        <Table
                                            :headers="header"
                                            :items="payScalesData"
                                            class="w-full mt-4 mb-4"
                                            aria-label="payScales table"
                                            :has-number="true"
                                            :loading="loading"
                                        >
                                        <template v-slot:item="{ item }">
                                            <div v-if="item.payScaleId">
                                                <span class="font-normal text-sm leading-5 text-darkPurple">
                                                    {{ item.data.payScaleId ? item.data.payScaleId : '-----' }}
                                                </span>
                                            </div>
                                            <div v-else-if="item.jobClassificationNames">
                                                <div v-if="item.data.jobClassificationNames?.length">
                                                    <div class="flex flex-col justiy-start gap-2">
                                                        <div class="flex flex-row justify-between items-center gap-1">
                                                            <p class="text-sm text-darkPurple">
                                                                {{ item.data.jobClassificationNames[0] }}
                                                            </p>
                                                            <template v-if="item.data.jobClassificationNames.length - 1 > 0">
                                                                <p class="text-xs text-flame font-bold">
                                                                +{{ item.data.jobClassificationNames.length - 1 }}
                                                                </p>
                                                            </template>
                                                        </div>
                                                        <template v-if="item.data.jobClassificationNames.length > 1">
                                                        <div @click="
                                                            (activeJobClassificationNames = item.data.jobClassificationNames),
                                                            (isOpenJobClassificationNames = true)
                                                            ">
                                                            <p class="text-xs text-blueCrayola font-semibold cursor-pointer">
                                                                View Trail
                                                            </p>
                                                        </div>
                                                        </template>
                                                    </div>
                                                </div>
                                                <div v-else class="font-normal text-sm leading-5 text-darkPurple">
                                                 -----
                                                </div>
                                            </div>
                                            <div v-else-if="item.jobTitleNames">
                                                <div v-if="item.data.jobTitleNames?.length">
                                                    <div class="flex flex-col justiy-start gap-2">
                                                        <div class="flex flex-row justify-between items-center gap-1">
                                                        <p class="text-sm text-darkPurple">
                                                            {{ item.data.jobTitleNames[0] }}
                                                        </p>
                                                        <template v-if="item.data.jobTitleNames.length - 1 > 0">
                                                            <p class="text-xs text-flame font-bold">
                                                            +{{ item.data.jobTitleNames.length - 1 }}
                                                            </p>
                                                        </template>
                                                        </div>
                                                        <template v-if="item.data.jobTitleNames.length > 1">
                                                        <div @click="
                                                            (activeDesignationNames = item.data.jobTitleNames),
                                                            (isOpenDesignationNames = true)
                                                            ">
                                                            <p class="text-xs text-blueCrayola font-semibold cursor-pointer">
                                                                View Trail
                                                            </p>
                                                        </div>
                                                        </template>
                                                    </div>
                                                </div>
                                                <div v-else class="font-normal text-sm leading-5 text-darkPurple">
                                                    -----
                                                </div>
                                            </div>
                                            <div v-else-if="item.levelNames">
                                                <span class="font-normal text-sm leading-5 text-darkPurple">
                                                    {{ item.data.levelNames?.[0] ? item.data.levelNames[0]  : '-----' }}
                                                </span>
                                            </div>
                                            <div v-else-if="item.jobGradeNames" class="flex justify-start items-center gap-4">
                                                <div class="font-normal text-sm leading-5 text-darkPurple">
                                                    {{ item.data.jobGradeNames?.[0] ? item.data.jobGradeNames[0]  : '-----' }}
                                                </div>
                                                <div
                                                    v-if="payScaleGroupTypeForHeader === 'gradeLevel' && item.data.jobGradeNames?.length > 1"
                                                    class="relative"
                                                    @mouseenter="onEnter()" @mouseleave="onLeave()"
                                                >
                                                    <p class="text-xs text-blueCrayola font-semibold cursor-pointer">
                                                        +{{ item.data.jobGradeNames.length - 1 }}
                                                    </p>
                                                    <ToolTip v-if="IsStepToolTip" class="step-tooltip" right="5px">
                                                        <div class="flex justify-start items-center whitespace-nowrap">
                                                            <div v-for="(step, index) in item.data.jobGradeNames" :key="index">
                                                                <p class="text-white">
                                                                    {{ step }}<span v-if="index < item.data.jobGradeNames.length - 1">,</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </ToolTip>
                                                </div>
                                            </div>
                                            <div v-else-if="item.payScaleAmount">
                                                <span class="font-normal text-sm leading-5 text-darkPurple">
                                                    {{ item.data.payScaleAmount ? item.data.payScaleAmount  : '-----' }}
                                                </span>
                                            </div>
                                            <span v-else-if="item.id">
                                                <Menu left top="-150" margin="24" class="my-2 p-0">
                                                    <template v-slot:title>
                                                        <icon icon-name="more_icon" size="xs" />
                                                    </template>
                                                    <div
                                                        class="w-48 flex flex-col justify-start items-center gap-3 px-3 py-2"
                                                    >
                                                        <div @click="onPayScaleActions('editPayscale', item.data.id)" class="w-full">
                                                            <div
                                                                class="w-full px-2 py-1 rounded-md flex justify-start items-center gap-2 cursor-pointer hover:bg-cultured"
                                                            >
                                                                <Icon icon-name="edit" class-name="text-blueCrayola" size="xs" />
                                                                <span class="text-sm font-normal leading-5 text-darkPurple">Edit</span>
                                                            </div>
                                                        </div>
                                                        <div @click="onPayScaleActions('deletePayscale', item.data.id)" class="w-full">
                                                            <div
                                                                class="w-full px-2 py-1 rounded-md flex justify-start items-center gap-2 cursor-pointer hover:bg-cultured"
                                                            >
                                                                <Icon icon-name="delete" class-name="text-flame bg-white" size="xs" />
                                                                <span class="text-sm font-normal leading-5 text-darkPurple">Delete</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Menu>
                                            </span>
                                        </template>
                                        </Table>
                                    </div>
                                    <div
                                        class="w-full flex flex-col mt-4 p-2 justify-center items-center"
                                        v-else
                                    >
                                        <p class="text-base my-2">
                                            There are no pay scale at the moment.
                                        </p>
                                    </div>
                                </div>
                            </card>
                        </div> 
                    </div>
                </div>
            </div>
            <div
                class="w-full flex flex-col mt-4 p-2 justify-center items-center"
                v-else
            >
                <p class="text-base my-2">
                    There are no pay scale at the moment!!!!!.
                </p>
            </div>

        <template>
            <Modal v-if="isOpenDelete">
                <Card class="p-5 flex flex-col max-w-md">
                <div class>
                    <p class="font-bold ml-4 my-5 text-center">
                        Are you sure you want to delete this payScale?
                    </p>
                    <div class="flex justify-end items-center gap-2">
                    <Button @click="onDelete(delPayScaleId)"
                        class="flex items-center justify-center text-white bg-dynamicBackBtn w-28 h-10"
                    >
                        Delete
                    </Button>
                    <Button @click="isOpenDelete = false"
                        class="flex items-center justify-center text-dynamicBackBtn w-28 h-10 bg-white border border-dynamicBackBtn"
                    >
                        Cancel
                    </Button>
                    </div>
                </div>
                </Card>
            </Modal>
        </template>
        <template>
          <RightSideBar v-if="isOpenDesignationNames" @close="isOpenDesignationNames = false"
            button-class="bg-dynamicBackBtn text-white" :close-button="true">
            <template v-slot:title>
              <div class="flex justify-start items-center">
                <p class="text-darkPurple font-bold text-lg leading-5 p-0 -ml-2">
                  View All Positions
                </p>
              </div>
            </template>
            <template v-slot:default>
              <div class="flex flex-col justify-start gap-2">
                <Card v-for="(name, index) in activeDesignationNames" :key="index" class="w-full">
                  <div class="flex flex-row items-center justify-start gap-2 mx-5 my-3">
                    <Icon icon-name="icon-grid" class="text-romanSilver" size="xxs" />
                    <h6 class="font-semibold text-sm text-jet capitalize">
                      {{ name }}
                    </h6>
                  </div>
                </Card>
              </div>
            </template>
          </RightSideBar>
        </template>
        <template>
          <RightSideBar v-if="isOpenJobClassificationNames" @close="isOpenJobClassificationNames = false"
            button-class="bg-dynamicBackBtn text-white" :close-button="true">
            <template v-slot:title>
              <div class="flex justify-start items-center">
                <p class="text-darkPurple font-bold text-lg leading-5 p-0 -ml-2">
                  View All Job Cadre
                </p>
              </div>
            </template>
            <template v-slot:default>
              <div class="flex flex-col justify-start gap-2">
                <Card v-for="(name, index) in activeJobClassificationNames" :key="index" class="w-full">
                  <div class="flex flex-row items-center justify-start gap-2 mx-5 my-3">
                    <Icon icon-name="icon-grid" class="text-romanSilver" size="xxs" />
                    <h6 class="font-semibold text-sm text-jet capitalize">
                      {{ name }}
                    </h6>
                  </div>
                </Card>
              </div>
            </template>
          </RightSideBar>
        </template>

        <add-edit-scale-based v-if="isAddEditScaleBased"
            :pay-scale-cred="payScaleCredentials"
            :edit-mode="editMode"
            :pay-scale-group-type-for-header="payScaleGroupTypeForHeader"
            :group-id="payScaleCurrentTabId"
            @close="isAddEditScaleBased = false, editMode = false"
            @reload="reload()"
        />
        <add-edit-scale-based-group-type v-if="isAddEditScaleGroupType"
            :scale-group-data="scaleGroupData"
            :edit-mode="isEditScaleGroupType"
            :group-id="payScaleCurrentTabId"
            @close=" isAddEditScaleGroupType = false, isEditScaleGroupType = false"
            @reload="reload()"
        />
        <import-employee :open-modal="isOpenImport" @close="isOpenImport = false"
            :isOverwriteEmployee="false" :isTemplate="true" @download="downloadCompensationTemplate()"
            @reload-employees="reload()" @importEmployee="importCompensation" :url=" url" 
            :title="`Import Compensation Data`" :is-employee-directory="false" :isDisplayProgressBar="false"
        />
        </template>
        <ErrorComponent v-else />
    </div>
</template>

<script>
import Table from "@scelloo/cloudenly-ui/src/components/table";
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import Card from "@/components/Card";
import Icon from "@/components/Icon";
import CardFooter from "@/components/CardFooter";
import Menu from "@scelloo/cloudenly-ui/src/components/Menu";
import Modal from "@/components/Modal"
import ImportEmployee from "@/components/importEmployee";
import Loader from "@scelloo/cloudenly-ui/src/components/loader";
import ErrorComponent from "@/modules/Admin/error403";

export default {
  name: "ScaleBased",
  components: {
    Table,
    Tab,
    Card,
    Icon,
    Menu,
    Modal,
    Loader,
    CardFooter,
    ImportEmployee,
    ErrorComponent,
    RadioButton: () => import("@/components/RadioButton"),
    RightSideBar: () => import("@/components/RightSideBar"),
    AddEditScaleBased: () => import("./Modals/AddEditScaleBased.vue"),
    AddEditScaleBasedGroupType: () => import("./Modals/AddEditScaleBasedGroupType.vue"),
    PaySettingsTabs: () => import("@/modules/Admin/SettingsModule/PayrollSettings/PaySettingsTabs"),
    ToolTip: () => import('@/components/ToolTip')
  },
  data() {
    return {
        IsStepToolTip: false,
        hasModuleAccess: false,
        activeDesignationNames: [],
        isOpenDesignationNames: false,
        activeJobClassificationNames: [],
        isOpenJobClassificationNames: false,
        scaleGroupData: {},
        isAddEditScaleGroupType: false,
        isEditScaleGroupType: false,
        payScaleCredentials: {},
        delPayScaleId: "",
        editMode: false,
        isOpenDelete: false,
        isAddEditScaleBased: false,
        isloading: true,
        loading: true,
        payScaleCurrentTabId: "", 
        payScaleTabs: [],
        payScalesData: [],
        payScaleGroupType: null,
        payScaleGroupTypeForHeader: null,
        updatePayScaleGroupType: [
            { name: "Post", radioName: "updatePayScaleGroupType", value: 'post' },
            { name: "Grade Level/ Step", radioName: "updatePayScaleGroupType", value: 'gradeLevel' }
        ],
        url: `${process.env.VUE_APP_UPLOAD_CLOUDENLY_FILES}/upload/designations`,
        isOpenImport: false,
    };
  },
  computed:{
    tabs() {
        return this.payScaleTabs;
    },
    header(){
        if (this.payScaleGroupTypeForHeader === 'gradeLevel') {
            return [
                { title: "Payscale ID", value: "payScaleId" },
                { title: "cadre(s)", value: "jobClassificationName" },
                { title: "grade level", value: "levelNames" },
                { title: "step", value: "jobGradeNames" },
                { title: "pay scale", value: "payScaleAmount" },
                { title: "", value: "id", image: true },
                ];
        } 
        if(this.payScaleGroupTypeForHeader === 'post') {
            return [
                { title: "Payscale ID", value: "payScaleId" },
                { title: "cadre(s)", value: "jobClassificationNames" },
                { title: "Post", value: "jobTitleNames" },
                { title: "pay scale", value: "payScaleAmount" },
                { title: "", value: "id", image: true },
            ];
            }
        }
    },
  methods: {
    onEnter(){
        this.IsStepToolTip = true;
    },
    onLeave(value){
        this.IsStepToolTip = false;
    },
    async onPayScaleActions(setAction, payload) {
      try {
        if (setAction === "importPayScale") {
          await this.$handlePrivilege("compensationPayscale", "importPayScale");
          this.isOpenImport = true;
        } else if (setAction === "addNewPayScale") {
          await this.$handlePrivilege("compensationPayscale", "addNewPayScale");
          this.isAddEditScaleBased = true;
        } else if (setAction === "editPayscale") {
          await this.$handlePrivilege("compensationPayscale", "editPayscale");
          this.onEditOnePayScale(payload);
        } else if (setAction === "deletePayscale") {
          await this.$handlePrivilege("compensationPayscale", "deletePayscale");
          this.delPayScaleId = payload;
          this.isOpenDelete = true;
        }
      } catch (error) {
        const message = "You do not have permission to perform this task";
        this.$toasted.error(message, { duration: 3000 });
      }
    },
    async onSalaryScaleTabAction(setAction) {
      try {
        await this.$handlePrivilege("compensationPayscale", "addNewSalaryScale");
        if (setAction === "edit") {
          this.isAddEditScaleGroupType = true;
          this.isEditScaleGroupType = true;
        } else {
          this.isAddEditScaleGroupType = true;
        }
      } catch (error) {
        const message = "You do not have permission to perform this task";
        this.$toasted.error(message, { duration: 3000 });
      }
    },
    async onDefineScaleCategory() {
      const previousType = this.payScaleGroupTypeForHeader;
      try {
        await this.$handlePrivilege("compensationPayscale", "defineScaleCatergory");
        await this.switchPayScaleGroupType();
      } catch (error) {
        this.payScaleGroupType = previousType;
        const message = "You do not have permission to perform this task";
        this.$toasted.error(message, { duration: 3000 });
      }
    },
    handleCurrentTab(tabId) {
        this.payScaleCurrentTabId = tabId;
        this.getAllPayScales();
    },
    handleNextTab(tabId) {
      this.handleCurrentTab(tabId);
    },
    handlePreviousTab(tabId) {
      this.handleCurrentTab(tabId);
    },
    async getAllPayScales(){
        this.loading = true;
        try {
            const { data } = await this.$_getAllOrgPayScales();
            this.payScaleCurrentTabId = !this.payScaleCurrentTabId ? data.data.groups[0].id : this.payScaleCurrentTabId;
            this.payScaleTabs = data.data.groups.map((item) => ({
                    name: item.name,
                    id: item.id,
                }));
            this.payScaleGroupType = !this.payScaleGroupType ? data.data.payScaleGroupType : this.payScaleGroupType;
            this.payScaleGroupTypeForHeader = !this.payScaleGroupTypeForHeader ? data.data.payScaleGroupType : this.payScaleGroupTypeForHeader
            const selectedPayScaleData = data.data.groups.filter(el => el.id === this.payScaleCurrentTabId);
            this.payScalesData = selectedPayScaleData[0].payScales;
            this.scaleGroupData = {
                name: selectedPayScaleData[0].name,
                description: selectedPayScaleData[0].description
            }
            this.loading = false;
            this.isloading = false;
        } catch (error) {
            this.loading = false;
            this.isloading = false;
            this.$toasted.error('Error fetching pay scale', {duration: 3000})
        }
    },
    async switchPayScaleGroupType(){
        const payload = {
            payScaleGroupType: this.payScaleGroupType
        }
        try {
            const { data } = await this.$_switchPayScaleGroupType(payload);
            this.payScaleGroupType = data.data.payScaleGroupType;
            this.payScaleGroupTypeForHeader = data.data.payScaleGroupType; 
            this.getAllPayScales();
            this.$toasted.success(data.message, {duration: 3000})
        } catch (error) {
            this.payScaleGroupType = this.payScaleGroupTypeForHeader;
            this.$toasted.error(error, {duration: 3000})
        }
    },
    reload() {
      this.getAllPayScales();
    },
    onDelete(payScaleId) {
        this.loading = true;
        this.isloading = true;
        this.isOpenDelete = false;

        this.$_deleteOnePayScale(payScaleId)
          .then(({ data }) => {
            this.$toasted.success(data.message, { duration: 3000 });
            this.loading = false;
            this.isloading = false;
            this.getAllPayScales();
          })
          .catch((error) => {
            this.loading = false;
            this.isloading = false;
            this.$toasted.error(error.message, { duration: 3000 });
        });
    },
    onEditOnePayScale(payScaleId){
        this.$_getOnePayScale(payScaleId)
        .then(({ data }) => {
            this.payScaleCredentials = data?.data.payScale;
            this.payScaleCredentials.levelIds = data?.data?.payScale?.levelIds?.[0];
          this.editMode = true;
          this.isAddEditScaleBased = true;
        }).catch((error) => {
          this.editMode = false;
          this.isAddEditScaleBased = false;
          this.$toasted.error(error.message, { duration: 3000 });
        });
    },
    async importCompensation(fileUrl, overwriteEmployee, { resolve, reject }) {
      try {  
        const payload = {
          fileUrl,
        };
        const response = await this.$_importCompensation(payload, this.payScaleCurrentTabId);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    },
    async downloadCompensationTemplate(){
      try {
        const response = await this.$_getCompensationTemplate(this.payScaleCurrentTabId);
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Compensation Template`;
        // Appended the link to the body (necessary for Firefox)
        document.body.appendChild(link);
        link.click();

        // Removed the link after download
        document.body.removeChild(link);
      } catch (error) {
          return this.$toasted.error(`Error downloading file`,{duration: 6000});
      }
    }
  },
  async mounted() {
    try {
      await this.$handlePrivilege("compensationPayscale", "accessSalaryScaleRegister");
      this.hasModuleAccess = true;
      await this.getAllPayScales();
    } catch (error) {
      this.hasModuleAccess = false;
      this.isloading = false;
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.bg-color{
  border: 1px solid #E993235C;
  background: #E9932314;
}
.step-tooltip {
    width: max-content !important;
    min-width: 0 !important;
}
</style>